/**
 * Share referral localStorage helpers.
 * Stores share link IDs per post with 7-day expiry.
 */

export function saveShareRef(postId, shareId) {
  try {
    localStorage.setItem('primal_ref_' + postId, JSON.stringify({ shareId: shareId, timestamp: Date.now() }));
  } catch (e) {}
}

export function loadShareRef(postId) {
  try {
    var raw = localStorage.getItem('primal_ref_' + postId);
    if (!raw) return null;
    var data = JSON.parse(raw);
    if (Date.now() - data.timestamp > 604800000) {
      localStorage.removeItem('primal_ref_' + postId);
      return null;
    }
    return data.shareId;
  } catch (e) { return null; }
}

export function clearShareRef(postId) {
  try { localStorage.removeItem('primal_ref_' + postId); } catch (e) {}
}
